export default __webpack_public_path__ + "60d62abe4e7d7db0390663c0340bb81f.svg";